import { Link } from "react-router-dom";

import { ModalPopUp } from "../../../../../components/ModalPopUp";
import { caseFilter } from "./constants/";
import "./index.scss";
import { ListEletronicsStoreProvider } from "./store";
import useListEletronicStore from "./store/useStore";
import { AutoCompleteList } from "../../../../../libs/autoCompleteList";
import { ModalDeleteContent } from "./components/ModalExit";
import FilterEletronics from "./components/FilterEletronics";
import TableEletronics from "./components/TableEletronics";
import Spinner from "../../../../../components/Spinner";

export function ListInventoryEletronics() {
  return (
    <ListEletronicsStoreProvider>
      <InventoryEletronicsList />
    </ListEletronicsStoreProvider>
  );
}

export function InventoryEletronicsList() {
  const { filterSelect, modalStatus, nameItem, inactiveOrActive, eletronicActived, eletronicInactived, needSpinner } = useListEletronicStore();
  const { setModalStatus, setNameItem } = useListEletronicStore();

  function exitPopUp() {
    return setModalStatus({ status: false, id: 0 });
  }

  return (
    <>
      <datalist id="dataList">
        {AutoCompleteList(inactiveOrActive ? eletronicInactived : eletronicActived, [caseFilter[filterSelect - 1]])?.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </datalist>

      <ModalPopUp status={modalStatus.status} onClickCancel={exitPopUp} title={nameItem}>
        <ModalDeleteContent setNameItem={setNameItem} />
      </ModalPopUp>

      <div className="margin-screen">
        <div className="box-title">
          <h1 className="font-poppins"> Inventário - Eletrônicos {inactiveOrActive ? "| Inativo" : "| Ativo"} </h1>
          <Link className="Link btn bg-primary" to="/eletronic-inventory/form">
            {" "}
            Adicionar item
          </Link>
        </div>
        <Spinner status={needSpinner}>
          <FilterEletronics />
          <TableEletronics />
        </Spinner>
      </div>
    </>
  );
}
